import React from 'react';
import { Info } from 'lucide-react';

const BASE_LABEL_CLASS =
  'text-[9px] font-black uppercase tracking-widest text-slate-400 ml-1';

export default function CrmFieldLabel({
  label,
  tooltip,
  className = '',
  labelClassName = '',
  iconClassName = '',
}) {
  return (
    <div className={`mb-1 flex items-center gap-1.5 ${className}`}>
      <span className={`${BASE_LABEL_CLASS} ${labelClassName}`}>{label}</span>
      {tooltip ? (
        <span
          title={tooltip}
          aria-label={tooltip}
          tabIndex={0}
          className={`inline-flex h-4 w-4 items-center justify-center rounded-full border border-slate-200 bg-white text-[#0B2A36] outline-none transition-all hover:border-[#51A7FD]/40 hover:text-[#51A7FD] focus:border-[#51A7FD]/40 focus:text-[#51A7FD] ${iconClassName}`}
        >
          <Info size={10} />
        </span>
      ) : null}
    </div>
  );
}
